// extracted by mini-css-extract-plugin
module.exports = {"partnersContainer":"Partners_partnersContainer__3Pu7e","imageContainer":"Partners_imageContainer__2T2IE"};